// extracted by mini-css-extract-plugin
export default {"inputDate":"DatePicker_inputDate__Gj3jv","root":"DatePicker_root__dtH25"};